<template>
    <div class="mx-auto">
        <slot></slot>
    </div>
</template>
<script setup></script>
<style scoped></style>